/**
 * Created by sxp23 on 3/16/2018.
 */
import {
  NgModule, Component, ElementRef, AfterContentInit, OnDestroy, Input, Output, EventEmitter,
  ContentChildren, QueryList, ChangeDetectorRef, Inject, forwardRef
} from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { SharedModuleC, HeaderC } from './shared';
//import { BlockableUI } from '../common/blockableui';
import { Subscription } from 'rxjs';

import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

let idx: number = 0;

@Component({
  selector: 'p-accordionTab-c',
  template: `
        <div class="ui-accordion-header ui-state-default ui-corner-all" [ngClass]="{'ui-state-active': selected,'ui-state-disabled':disabled}">
            <a href="#" [attr.id]="id" [attr.aria-controls]="id + '-content'" role="tab" [attr.aria-expanded]="selected" (click)="toggle($event)" (keydown.space)="toggle($event)">
                <span class="ui-accordion-toggle-icon" [ngClass]="selected ? accordion.collapseIcon : accordion.expandIcon"></span>
                <span class="ui-accordion-header-text" *ngIf="!hasHeaderFacet">
                    {{header}}&nbsp;
                     <i *ngIf="infoIcon=='awqr'" class="btn-icon fa fa-info-circle pws" placement="bottom" (click)="open(contentAWQR)"></i>
                     <i *ngIf="infoIcon=='selPWS'" class="btn-icon fa fa-info-circle pws" placement="bottom" (click)="open(contentSelPWS)"></i>
                </span>
                <ng-content select="p-header" *ngIf="hasHeaderFacet"></ng-content>
            </a>
        </div>
        <div [attr.id]="id + '-content'" class="ui-accordion-content-wrapper" [@tabContent]="selected ? 'visible' : 'hidden'" (@tabContent.done)="onToggleDone($event)"
            [ngClass]="{'ui-accordion-content-wrapper-overflown': !selected||animating}" 
            role="region" [attr.aria-hidden]="!selected" [attr.aria-labelledby]="id">
            <div class="ui-accordion-content ui-widget-content" *ngIf="lazy ? selected : true">
                <ng-content></ng-content>
            </div>
        </div>
        <ng-template #contentSelPWS let-c="close" let-d="dismiss">
  <div class="modal-body">
    <!--<p>Select from the public water systems serving greater than 3,300 people to view the Annual Drinking Water Quality Report and contact information. For information on smaller public water systems, contact your local health department at <a href="http://www.health.ny.gov/EnvironmentalContacts" target="_blank">www.health.ny.gov/EnvironmentalContacts</a>.</p>-->
    <p>Find and map the public water system closest to you. View the drinking water system boundary, Annual Drinking Water Quality Report and contact information. Public water system information shown are those serving greater than 3,300 people. <br/><br/> For information on smaller public water systems, contact your local health department at: <a href="http://www.health.ny.gov/EnvironmentalContacts" target="_blank">www.health.ny.gov/EnvironmentalContacts</a>.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c('Close click')">Close</button>
  </div>
</ng-template>
<ng-template #contentAWQR let-c="close" let-d="dismiss">
  <div class="modal-body">
    <p><span ngbAutoFocus></span>To identify the source of your drinking water, review the Annual Water Quality Report.  It contains information about the system&rsquo;s water source, contaminants, and violations of drinking water regulations. Public water system information shown are those serving greater than 3,300 people nearest to this address. Annual Water Quality Reports present information based on a calendar year and are completed the following spring after all data are received. Reports are reviewed by NYSDOH prior to posting.<br/><br/>Learn more about <a href="http://www.health.ny.gov/environmental/water/drinking/annual_water_quality_report/" target="_blank">water quality reports</a>.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="c('Close click')">Close</button>
  </div>
</ng-template>
    `,
  animations: [
    trigger('tabContent', [
      state('hidden', style({
        height: '0'
      })),
      state('visible', style({
        height: '*'
      })),
      transition('visible <=> hidden', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ]
})
export class AccordionTabC implements OnDestroy {

  @Input() header: string;

  @Input() infoIcon: string;

  @Input() isMobile: boolean;

  @Input() selected: boolean;

  @Input() disabled: boolean;

  @Output() selectedChange: EventEmitter<any> = new EventEmitter();

  @ContentChildren(HeaderC) headerFacet: QueryList<HeaderC>;

  animating: boolean;

  id: string = `ui-accordiontab-${idx++}`;

  constructor(private modalService: NgbModal, @Inject(forwardRef(() => AccordionC)) public accordion: AccordionC) { }

  open(content) {
    this.selected = !this.selected;
    this.modalService.open(content, { size: 'lg', windowClass: 'modal-adaptive' });
  }

  toggle(event) {
    if (this.disabled || this.animating) {
      return false;
    }

    this.animating = true;
    let index = this.findTabIndex();

    if (this.selected) {
      this.selected = false;
      this.accordion.onClose.emit({ originalEvent: event, index: index });
    }
    else {
      if (!this.accordion.multiple) {
        for (var i = 0; i < this.accordion.tabs.length; i++) {
          this.accordion.tabs[i].selected = false;
          this.accordion.tabs[i].selectedChange.emit(false);
        }
      }

      this.selected = true;
      this.accordion.onOpen.emit({ originalEvent: event, index: index });
    }

    this.selectedChange.emit(this.selected);

    event.preventDefault();
  }

  findTabIndex() {
    let index = -1;
    for (var i = 0; i < this.accordion.tabs.length; i++) {
      if (this.accordion.tabs[i] == this) {
        index = i;
        break;
      }
    }
    return index;
  }

  get lazy(): boolean {
    return this.accordion.lazy;
  }

  get hasHeaderFacet(): boolean {
    return this.headerFacet && this.headerFacet.length > 0;
  }

  onToggleDone(event: Event) {
    this.animating = false;
  }

  ngOnDestroy() {
    this.accordion.tabs.splice(this.findTabIndex(), 1);
  }
}

@Component({
  selector: 'p-accordion-c',
  template: `
        <div [ngClass]="'ui-accordion ui-widget ui-helper-reset'" [ngStyle]="style" [class]="styleClass" role="presentation">
            <ng-content></ng-content>
        </div>
    `
})
export class AccordionC implements AfterContentInit, OnDestroy {

  @Input() multiple: boolean;

  @Output() onClose: EventEmitter<any> = new EventEmitter();

  @Output() onOpen: EventEmitter<any> = new EventEmitter();

  @Input() style: any;

  @Input() styleClass: string;

  //@Input() expandIcon: string = 'fa fa-fw fa-caret-right';
  //@Input() collapseIcon: string = 'fa fa-fw fa-caret-down';
  @Input() expandIcon: string = 'fa fa-fw fa-caret-down';
  @Input() collapseIcon: string = 'fa fa-fw fa-caret-up';

  @Input() lazy: boolean;

  @ContentChildren(AccordionTabC) tabList: QueryList<AccordionTabC>;

  tabListSubscription: Subscription;

  private _activeIndex: any;

  public tabs: AccordionTabC[] = [];

  constructor(public el: ElementRef, public changeDetector: ChangeDetectorRef) { }

  ngAfterContentInit() {
    this.initTabs();

    this.tabListSubscription = this.tabList.changes.subscribe(_ => {
      this.initTabs();
      this.changeDetector.markForCheck();
    });
  }

  initTabs(): any {
    this.tabs = this.tabList.toArray();
    this.updateSelectionState();
  }

  /*getBlockableElement(): HTMLElement {
    return this.el.nativeElement.children[0];
  }*/

  @Input() get activeIndex(): any {
    return this._activeIndex;
  }

  set activeIndex(val: any) {
    this._activeIndex = val;
    this.updateSelectionState();
  }

  updateSelectionState() {
    if (this.tabs && this.tabs.length && this._activeIndex != null) {
      for (let i = 0; i < this.tabs.length; i++) {
        let selected = this.multiple ? this._activeIndex.includes(i) : (i === this._activeIndex);
        let changed = selected !== this.tabs[i].selected;

        if (changed) {
          this.tabs[i].animating = true;
        }

        this.tabs[i].selected = selected;
        this.tabs[i].selectedChange.emit(selected);
      }
    }
  }

  ngOnDestroy() {
    if (this.tabListSubscription) {
      this.tabListSubscription.unsubscribe();
    }
  }
}

@NgModule({
  imports: [CommonModule],
  exports: [AccordionC, AccordionTabC, SharedModuleC],
  declarations: [AccordionC, AccordionTabC]
})
export class AccordionCustomModule { }
